export enum TripleAnwer {
	NO = 'NO',
	NOT_APPLICABLE = 'NOT_APPLICABLE',
	YES = 'YES',
}
